import { ButtonBase, ButtonBaseProps } from './ButtonBase'

type PrimaryButtonProp = ButtonBaseProps & {}

export function PrimaryButton({ ...props }: PrimaryButtonProp) {
  return <ButtonBase color="primary" {...props} />
}
